import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Very%20faint%20soft%20abstract%20product%20photography%20collage%20with%20fashion%20items%20on%20cream%20backgrounds%20in%20scattered%20pattern%2C%20extremely%20muted%20and%20faded%20texture%2C%20almost%20invisible%20watermark%20style%2C%20warm%20neutral%20cream%20and%20sand%20tones%2C%20minimalist%20seamless%20pattern%20feel&width=1200&height=600&seq=itaobuy-cta-v2-bg&orientation=landscape')`,
        }}
      ></div>

      <div className="relative z-10 max-w-[800px] mx-auto text-center px-6 md:px-10">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
          Pronto a Scoprire Itaobuy Spreadsheet?
        </h2>
        <p className="text-foreground-500 text-base md:text-lg mb-10 max-w-[560px] mx-auto">
          Accedi ora alla piattaforma completa con tutte le categorie, i prodotti e le guide
          di cui hai bisogno per acquistare in modo pi&ugrave; intelligente.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            itaobuy sheet
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-8 py-4 rounded-full bg-accent-500 text-white font-semibold text-base hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
          >
            buy it now
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}